import { http } from '@/http/axios.js'
// 列表
export function getAliOssSts() {
    return http({
        url: `/adminapi/file/sts`,
        method: 'POST'
    })
}
